export default "__VITE_ASSET__tuXkb27n__"